export const FALL_PERIOD_MS = 4 * 24 * 60 * 60 * 1000;

export function fallCycleState(start, now, count) {
  if (!Number.isFinite(start) || !Number.isFinite(now) || count < 1) return null;
  const elapsed = Math.max(0, now - start);
  const cycle = Math.floor(elapsed / FALL_PERIOD_MS);
  return { index: cycle % count, remaining: FALL_PERIOD_MS - elapsed % FALL_PERIOD_MS };
}

if (typeof customElements !== 'undefined' && !customElements.get('med-fall-cycle')) {
  customElements.define('med-fall-cycle', class extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-fall-card]')];
      this.start = Date.parse(this.dataset.start);
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.tick);
    }

    tick() {
      const state = fallCycleState(this.start, Date.now(), this.cards.length);
      if (!state) {
        this.querySelectorAll('[data-fall-countdown]').forEach(el => el.hidden = true);
        return;
      }
      this.cards.forEach((card, index) => card.hidden = index !== state.index);
      this.dataset.activeIndex = state.index;
      if (this.activeIndex !== state.index) {
        const status = this.querySelector('[data-fall-status]');
        if (this.activeIndex !== undefined && status) status.textContent = this.cards[state.index].dataset.title;
        this.activeIndex = state.index;
      }
      const seconds = Math.ceil(state.remaining / 1000);
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds % 86400 / 3600),
        minutes: Math.floor(seconds % 3600 / 60),
        seconds: seconds % 60
      };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelectorAll(`[data-fall-${unit}]`).forEach(el => el.textContent = String(value).padStart(2, '0'));
      }
    }
  });
}
